<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="预计开启时间">
              <a-input placeholder="请输入预计开启时间" v-model="queryParam.startDate"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目实施中心">
              <a-input placeholder="请输入项目实施中心" v-model="queryParam.centerNames"></a-input>
            </a-form-item>
          </a-col>

          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否开启预实验，1是0否">
              <a-input placeholder="请输入是否开启预实验，1是0否" v-model="queryParam.beforeTest"></a-input>
            </a-form-item>
          </a-col> -->

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <tempConfigProject-modal ref="modalForm" @ok="modalFormOk"></tempConfigProject-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import TempConfigProjectModal from './modules/TempConfigProjectModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "TempConfigProjectList",
    mixins:[JeecgListMixin],
    components: {
      TempConfigProjectModal
    },
    data () {
      return {
        description: '项目配置-项目基本信息管理页面',
        // 表头
        columns: [
		   {
            title: '项目名称',
            align:"center",
            dataIndex: 'name'
           },
		   {
            title: '预计开启时间',
            align:"center",
            dataIndex: 'startDate'
           },
		   {
            title: '项目实施中心',
            align:"center",
            dataIndex: 'centerNames'
           },
		   {
            title: '项目实施中心',
            align:"center",
            dataIndex: 'centerIds'
           },
		  //  {
      //       title: '是否开启预实验，1是0否',
      //       align:"center",
      //       dataIndex: 'beforeTest'
      //      },
		   {
            title: '实验人数',
            align:"center",
            dataIndex: 'testNum'
           },
		   {
            title: '项目负责人',
            align:"center",
            dataIndex: 'personName'
           },
		   {
            title: '项目负责人',
            align:"center",
            dataIndex: 'personId'
           },
		   {
            title: '联系电话',
            align:"center",
            dataIndex: 'phone'
           },
		   {
            title: '项目简介',
            align:"center",
            dataIndex: 'intro'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/tempconfig/tempConfigProject/list",
          delete: "/tempconfig/tempConfigProject/delete",
       },
    }
  },
  computed: {
  },
    methods: {
     
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>